// import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';
import { JobNames } from '../framework.core/JobNames';
import { formatDateTime,formatDate, now } from '../dateUtils';
import { Decimalformat } from '../components/common/commonExportFormat';
import moment from 'moment';
import fastStorage from '../fastStorage';
import {storageKeyMap} from '../hooks/useSetEditedId';
import { orchidBaroShipmentStatus, orchidBaroWeight } from '../components/common/OrchidBaroListView';

function toColumnName(num) {
  for (var ret = '', a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
    ret = String.fromCharCode(parseInt((num % b) / a) + 65) + ret;
  }
  return ret;
}

export function exportDomTableIntoExcel(domId, title, userId, jobName, listview, appcontext) {
  const oiQuotation = 'ifms-list-data-/common/joblistview/oeQuotation/oceanExport?parentOp=oceanImport';
  const oeQuotation = 'ifms-list-data-/common/joblistview/oeQuotation/oceanExport?parentOp=oceanExport';
  const aiQuotation = 'ifms-list-data-/common/joblistview/aeQuotation/airExport?parentOp=airImport';
  const aeQuotation = 'ifms-list-data-/common/joblistview/aeQuotation/airExport?parentOp=airExport';

  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };

  // sheetname max 31. 공통 부분은 짧게 줄임.
  title = title.replace('Accounting', 'Acct');
  title = title.replace('Ocean Import', 'OI');
  title = title.replace('Ocean Export', 'OE');
  title = title.replace('Air Import','AI');
  title = title.replace('Air Export','AE');
  title = title.replace('Other Shipment','Other Ship');
  title = title.replace('Warehouse', 'WH');
  title = title.replace('Manifest-Manifest', 'Manifest');  // 중복 제거
  title = title.replace('Load-Load', 'Load');  // 중복 제거
  title = title.replace('Local D/O-Local D/O', 'Local D/O');  // 중복 제거
  title = title.replace('Customer List', 'Cust List');
  title = title.replace('Report (Manager)', 'Report');
  title = title.replace('Batch Recog History', 'Batch Recog');
  title = title.replace('Orchid Baaro-Orchid Baaro List', 'Orchid Baaro');
  title = title.replace(/[\\\/\?\*\[\]\:]/g, '_'); 
  wb.SheetNames.push(title);

  const wsObjects = [];

  const table = document.getElementById(domId);
  const columnWidths = [];
  const backgroundRows =[];

  const listDataStorageKey = `ifms-list-data-${storageKeyMap.get(jobName)}`;
  let listData;


  if (jobName === 'SQUOT') {
    listData = fastStorage[oiQuotation] ?? fastStorage[oeQuotation];
  } else if (jobName === 'AQUOT') {
    listData = fastStorage[aiQuotation] ?? fastStorage[aeQuotation];
  } else listData = fastStorage[listDataStorageKey];

  if (table && !!listData) {
    const rowHeaderColumns = table.querySelectorAll('div[id*="header"]');
    const generalRow = table.querySelectorAll('div[role="row"]');
    const firstRow = generalRow[1];
    const excelColType = listview.getExportRenderers(appcontext);
    const headerName = {};
    if (listData && !!firstRow) {
      listData.forEach((r, ri) => {
        let rowObj = {};
        rowHeaderColumns.forEach((c, ci) => {
          if (ci === 0) return;
          if (ri === 0) {
            columnWidths.push(c.getBoundingClientRect().width);
          }
          let header = rowHeaderColumns[ci].innerText ?? '';
          if (Object.keys(rowObj).some(key => key === header))
            header = header + 'Duptemp' + ci;
          const headerKey = rowHeaderColumns[ci].dataset.columnId ?? ''; 
          let specialRenderer = excelColType.find((x) => x.accessor === headerKey)?.changedValue;
          let hyperlinkRenderer = excelColType.find((x) => x.accessor === headerKey)?.hyperLink;
          let fontColorRenderer = excelColType.find((x) => x.accessor === headerKey)?.fontColor;
          let backColorRenderer = excelColType.find((x) => x.accessor === headerKey)?.backgroundColor;

          if (headerKey === 'status')
            rowObj[header] = (r[headerKey] === 'PC' ? 'Period Close' : '');
          else if (!!specialRenderer){
            if(!!fontColorRenderer){
              rowObj[header] = {
                v: specialRenderer(r),
                s: {
                  font: {
                    color: {rgb: fontColorRenderer(r)}
                  }
                }
              }
            } else {
              rowObj[header] = specialRenderer(r);
            }
          }
          else if(!!hyperlinkRenderer){
            if(hyperlinkRenderer(r)){
              rowObj[header] = {
                v: r[headerKey],
                l:{
                  Target: r[headerKey] ? hyperlinkRenderer(r): '',
                  ToolTip: r[headerKey] ? r[headerKey] : ''
                },
                s:{
                  font: {
                    color: {rgb: "0052BD"}
                  },
                }
              }
            } else {
              rowObj[header] = r[headerKey];
            }
          }
          else if(!!backColorRenderer){
            rowObj[header] = r[headerKey];
            backgroundRows.push({color:backColorRenderer(r)}); //backgroundColor 넣기 위해 추가
          }
          else if (!!firstRow.querySelectorAll(`div[id*=${headerKey}-]`)) {
            const firstElemet = firstRow.querySelectorAll(`div[id*=${headerKey}-]`)[0];
            if (firstElemet === undefined)
              rowObj[header] = r[headerKey] ?? '';
            else if (firstElemet.className.includes('-check-box'))
              rowObj[header] = r[headerKey] ? 'checked' : '';
            else if (firstElemet.className.includes('datetime'))
              rowObj[header] = formatDateTime(r[headerKey]);
            else if (firstElemet.className.includes('date'))
              rowObj[header] = formatDate(r[headerKey]);
            else if (firstElemet.className.includes('float'))
              rowObj[header] = Decimalformat(r[headerKey], 2);
            else
              rowObj[header] = r[headerKey] ?? '';
          }
          else
            rowObj[header] = r[headerKey] ?? '';

          if (ri === 0) {
            headerName[header] = header.includes('Duptemp') ? header.substring(0, header.indexOf('Duptemp')) : (headerKey === 'trStatus2' ? 'T' : header);
          }
        });
        if (ri === 0)
          wsObjects.push(headerName);
        wsObjects.push(rowObj);
      });
      console.log("wsobjects");
      console.log(wsObjects.length);


      //orchid baro일때 추가로 데이터 삽입
      if(jobName === JobNames.OrchidBaro){
        wsObjects.push({});
        wsObjects.push({});
        let rowObj = {};
        let header = rowHeaderColumns[2].innerText ?? '';
        let header2 = rowHeaderColumns[3].innerText ?? '';
        let header3 = rowHeaderColumns[5].innerText ?? '';
        let header4 = rowHeaderColumns[6].innerText ?? '';
        rowObj[header] = {
          v: 'Shipment Status',
          s: {font: {bold : true}}
        }
        rowObj[header3] = {
          v: 'Weight',
          s: {font: {bold : true}}
        }

        wsObjects.push(rowObj);
        for(let i = 0; i< orchidBaroShipmentStatus.length; i++){
          let rowObj = {};
            rowObj[header] = {
              v: '',
              s :{fill :{fgColor: {rgb: orchidBaroShipmentStatus[i].color}}}
            }
            rowObj[header2] = {
              v: orchidBaroShipmentStatus[i].label,
            }
            if(i < 3){
              rowObj[header3] = {
                v: '',
                s :{fill :{fgColor: {rgb: orchidBaroWeight[i].color}}}
              }
              rowObj[header4] = {
                v: orchidBaroWeight[i].label,
              }
            }
 
            wsObjects.push(rowObj);
          }
        }
      

        console.log(backgroundRows.length);

      const ws = XLSX.utils.json_to_sheet(wsObjects,{skipHeader: true});
      console.log(wsObjects.length, backgroundRows.length);

      //cell backgroundColor 추가
      if(wsObjects.length > 0 && backgroundRows.length > 0){
        for(let i =0; i < backgroundRows.length; i++){
          for(let c = 0; c < Object.keys(wsObjects[0]).length; c++){
            const cell = XLSX.utils.encode_cell({r:i+1,c: c});
          if(ws[cell]){
            if(backgroundRows[i].color == 'none'){
              continue;
            }else{
              if(ws[cell].s){
                ws[cell].s = {...ws[cell].s, fill:{fgColor:{rgb:backgroundRows[i].color}}}
              }else{
                ws[cell].s = {
                  fill:{fgColor:{rgb:backgroundRows[i].color}}
                  }
                }
              } 
            }
          }
        }
      }

      ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
      if (wsObjects.length > 0) {
        // Set up range under filter columns
        ws['!autofilter'] = { ref: `A1:${toColumnName(Object.keys(wsObjects[0]).length)}${wsObjects.length}` };
        //header column color 변경
        if(jobName === JobNames.OrchidBaro){
          for (let col = 0; col < wsObjects.length; col++) {
            const cell = toColumnName(col)+ '1';
            if (!ws[cell]) ws[cell] = {};  
            ws[cell].s = {
              font: {color: {rgb: "ffffff", bold: true}},
              fill: { fgColor: { rgb: 'D153C2' } }, 
            };
          }
        }        
      }

      wb.Sheets[title] = ws;
     
      const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
    
      XLSX.writeFile(wb, fileTitle, { compression: true});
    }
  }
}

export function exportCodeDataIntoExcel(data, title, columns) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    CreatedDate: new Date(),
  };

  title = title.replace(/[\\\/\?\*\[\]\:]/g, '_');
  wb.SheetNames.push(title);

  const wsObjects = [];
  const columnWidths = [];

  if (data) {
    data.forEach((r, ri) => {
      const rowObj = {};
      columns.forEach((c, ci) => {
        if (ri === 0) {
          columnWidths.push(columns[ci].width);
        }
        const header = columns[ci].dataIndex;
        const headerKey = columns[ci].text;
        if (headerKey === 'Inactive')
          rowObj[headerKey] = (r[header] === true ? 'Checked' : '');
        else if(headerKey === 'Inactive Date')
          rowObj[headerKey] = formatDate(r[header]);
        else
          rowObj[headerKey] = r[header];
      });

      wsObjects.push(rowObj);
    });
  }
  const ws = XLSX.utils.json_to_sheet(wsObjects);

  ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
  if (wsObjects.length > 0) {
    // Set up range under filter columns
    ws['!autofilter'] = { ref: `A1:${toColumnName(Object.keys(wsObjects[0]).length)}${wsObjects.length}` };
  }

  wb.Sheets[title] = ws;


  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();

  XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function readExcel(data) {
  const workBook = XLSX.read(data);
  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], {header:["A","B","C","D","E"], defval : '' });


  // workBook.SheetNames.forEach(function (sheetName) {
  //   console.log('SheetName: ' + sheetName);
  //   let rows = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
  //   console.log(JSON.stringify(rows));
  // })
  return rows;
}

function ExcelCCReader(bankDate, checkNo, bankAmount) {
  this.bankDate = bankDate
  this.checkNo = checkNo
  this.bankAmount = bankAmount
}

function ExcelWHPReader(billCode, billDesc, rate, qty, isVat, whType, whRefID) {
  this.billCode = billCode
  this.billDesc = billDesc
  this.rate = rate
  this.qty = qty
  this.isVat = isVat
  this.whType = whType
  this.whRefID = whRefID
}

function ExcelJournalReader(glNo, comType, comId, desc, debit, credit) {
  this.glNo = glNo
  this.comType = comType
  this.comId = comId
  this.desc = desc
  this.debit = debit
  this.credit = credit
}

export function readClearExcel(data, startRow, heading, dateformat, neg) {
  const list = new Array();
  const workBook = XLSX.read(data, {type: "string"});

  //heading = ["bankDate", "checkNo", "bankAmount","checkCondi","dateFormat","cehckCondiString"];

  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1, defval: ''});

  rows.forEach(row => {
    if (!row[heading[0]] || !row[heading[1]] || ((!row[heading[3]])&& heading[5].length !== 0)) return;
    if (row[heading[0]] === '' || row[heading[1]] === '') return;
    if ( !isNaN(Number(row[heading[3]])) || !row[heading[3]].includes(heading[5])) return;
    if (!moment(row[heading[0]], dateformat).isValid()) return;
    if (isNaN(Number(row[heading[2]]))) return;
    // if (isNaN(Number(row[heading[3]]))) return;

    let bankDate = moment.utc(row[heading[0]]).format(dateformat);
    let checkNo = row[heading[1]];
    checkNo = checkNo.replace(heading[5], "");
    checkNo = checkNo.replace("SUBSTITUTE CHECK", "");
    checkNo = checkNo.replace("CHECK", "");
    checkNo = checkNo.replace("Check #", "");
    checkNo = checkNo.replace("Check", "");
    checkNo = checkNo.replace(" ", "");

    let bankAmount = Number(row[heading[2]]);
    if (neg) bankAmount = -1 * bankAmount;

    list.push(new ExcelCCReader(bankDate, checkNo, bankAmount));
  });
  return list;
}

export function readJournalExcel(data) {
  const list = new Array();
  const workBook = XLSX.read(data, {type: "string"});
  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1, defval: ''});

  // Columns : Account Code, ComType, ComId, Description, Debit, Credit

  rows.forEach((row, i) => {
    if (i <= 0) return; // skip first row
    if (!row[0]) return;

    const glNo =  row[0];
    const comType = row[1];
    const comId = row[2];
    const desc = row[3];
    const debit = Number(row[4]);
    const credit = Number(row[5]);

    list.push(new ExcelJournalReader(glNo, comType, comId, desc, debit, credit));
  });
  return list;
}

export function readPeriodInvoiceExcel(data, heading) {
  const list = new Array();
  const workBook = XLSX.read(data, {type: "string"});

  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1, defval: ''});

  rows.forEach(row => {
    if (!row[heading[0]] || !row[heading[2]] || !row[heading[6]] || !row[heading[7]] ) return;
    if (isNaN(Number(row[heading[2]] ?? 0)) || isNaN(Number(row[heading[3]] ?? 0)) || !isNaN(Number(row[heading[6]] ?? 0))) return;
    if (row[heading[0]] === '' || row[heading[2]] === '' || row[heading[6]] === '' || row[heading[7]] === '') return;
    if (!['whr','whs'].includes(row[heading[6]].toLowerCase())) return;
  

    let billCode = row[heading[0]];
    let billDesc = row[heading[1]];
    let rate =  Number(row[heading[2]]);
    let qty = Number(row[heading[3]]);
    let isVat = row[heading[5]];
    let whType = row[heading[6]];
    let whRefID = row[heading[7]];

    list.push(new ExcelWHPReader(billCode, billDesc, rate, qty, isVat, whType, whRefID));
  });
  return list;
}

export function taxReturnWithXLExport(title,tbId,userId,addData){
  const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: title,
      Subject: title,
      Author: userId,
      CreatedDate: new Date(),
    };
    wb.SheetNames.push(title);

    const wsObjects = [];
    const headerName =[];
    const table = document.getElementById(tbId);
    const columnWidths = [];

    if(table){
      if(addData){
        addData.forEach((a) => {
          wsObjects.push(a);
        })
      }
      const rows = table.querySelectorAll('div[role="row"]');
      rows.forEach((r, ri) => {
        if(r.id && r.id.includes('-header-row')) {
          return;
        }
        const rowObj = [];
        const columns = r.querySelectorAll('div[role="cell"]');
        columns.forEach((c, ci) => {
          if (ri === 1){
            columnWidths.push(c.getBoundingClientRect().width);
          }
          const header = table.querySelector(`#${c.id.substring(0, c.id.indexOf('-cell-'))}-header-${ci}`);
          const headerKey = header?.innerText ?? ``;
             
          if(headerKey !== 'Select' && headerKey !== 'No'){
            if (ri === 1){
              headerName.push(headerKey);
            }
            rowObj.push(c.innerText);
          }
        });
        wsObjects.push(rowObj);
      });
      wsObjects.splice(addData.length,0,headerName);
    }
    const ws = XLSX.utils.aoa_to_sheet(wsObjects);
    ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
    wb.Sheets[title] = ws;

    const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
    XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function paymentToolWithXLExport(domId, title, userId, headerInfo, useBranch) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };

  wb.SheetNames.push(title);

  const wsObjects = [];
  const table = document.getElementById(domId);
  const columnWidths = [];
  const headerName =[];
  const headerName1 =[];
  const headerName2 =[];

  if (table) {
    // Type, Period 
    if (headerInfo) {
      headerInfo.forEach(x => {
        wsObjects.push(x);
      });
    }

    const rows = table.querySelectorAll('div[role="row"]');
    rows.forEach((r, ri) => {
      if (r.id && r.id.includes('-header-row')) {
        return;
      }
      const rowObj = [];
      let isSelect = false;
      let columnHorizontal = '';
      const columns = r.querySelectorAll('div[role="cell"]');
      columns.forEach((c, ci) => {
        const header = table.querySelector(`#${c.id.substring(0, c.id.indexOf('-cell-'))}-header-${ci}`);
        const headerKey = header?.innerText;

        if (headerKey !== 'No') {
          if (ri === 1) {
            if (headerKey) {
              headerName.push(headerKey);
              columnWidths.push(c.getBoundingClientRect().width);
            }
          }

          if (headerKey) {
            if(c.innerHTML.includes('ifms-table-align-left')){
              columnHorizontal = 'left';
            }
            else if(c.innerHTML.includes('ifms-table-align-right')){
              columnHorizontal = 'right';
            }
            else {
              columnHorizontal = 'center';
            }
            rowObj.push({v:c.innerText, t:"s", s:{alignment: {horizontal: columnHorizontal}}});
          } else if (ci === (useBranch ? 23 : 22)) {  // 선택 된 항목만 출력
            if (c.getElementsByClassName('e-ifms-checkbox-icon-base e-ifms-checkbox').length > 0) isSelect = true;
          }
        }
      });

      if (isSelect) wsObjects.push(rowObj);
    });

    // Header Column Cell Merge : Header Column 이름이 변경 될 경우 수정 필요
    const firstColHeader = headerName.map(x => {
      if (x.includes("(Bill)")) return x.replace(" (Bill)", "");
      else if (x.includes("(Due)")) return x.replace(" (Due)", "");
      else if (["Bill Amount", "Due Amount", "Amount"].includes(x)) return "Total";
      else return x
    });
    const secondColHeader = headerName.map(x => {
      if (x.includes("(Bill)")) return "Bill";
      else if (x.includes("(Due)")) return "Due";
      else return x
    });

    firstColHeader.forEach((c) => {
      headerName1.push({v:c, t:"s", s:{font:{bold: true}, alignment: {horizontal: 'center', vertical: 'center'}, 
                      border:{top:{style:'medium', color:'black'},
                              right:{style:'medium', color:'black'},
                              bottom:{style:'medium', color:'black'},
                              left:{style:'medium', color:'black'}}}});
    });
    secondColHeader.forEach((c) => {
      headerName2.push({v:c, t:"s", s:{font:{bold: true}, alignment: {horizontal: 'center', vertical: 'center'}, 
                      border:{top:{style:'medium', color:'black'},
                              right:{style:'medium', color:'black'},
                              bottom:{style:'medium', color:'black'},
                              left:{style:'medium', color:'black'}}}});
    });

    wsObjects.splice(headerInfo.length, 0, headerName2);
    wsObjects.splice(headerInfo.length, 0, headerName1);
  }
  const ws = XLSX.utils.aoa_to_sheet(wsObjects);

  if (wsObjects.length > 0) {
    ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
    // Set up range under filter columns
    // ws['!autofilter'] = { ref: `A5:${toColumnName(Object.keys(wsObjects[headerInfo.length]).length)}${wsObjects.length}` };
    if (useBranch) {
      ws['!merges'] = [
        {s: { r:0, c:0 }, e: { r:0, c:17 }},    // Title
        {s: { r:3, c:0 }, e: { r:4, c:0 }},     // Date
        {s: { r:3, c:1 }, e: { r:4, c:1 }},     // BR 
        {s: { r:3, c:2 }, e: { r:4, c:2 }},     // Bill No  
        {s: { r:3, c:3 }, e: { r:4, c:3 }},     // Customer
        {s: { r:3, c:4 }, e: { r:4, c:4 }},     // Ref. No
        {s: { r:3, c:5 }, e: { r:4, c:5 }},     // B/L No
        {s: { r:3, c:6 }, e: { r:4, c:6 }},     // CUR
        {s: { r:3, c:7 }, e: { r:3, c:8 }},     // AR
        {s: { r:3, c:9 }, e: { r:3, c:10 }},   // AP
        {s: { r:3, c:11 }, e: { r:3, c:12 }},   // Duty AR
        {s: { r:3, c:13 }, e: { r:3, c:14 }},   // Duty AP
        {s: { r:3, c:15 }, e: { r:3, c:17 }},   // Total
      ]
    } else {
      ws['!merges'] = [
        {s: { r:0, c:0 }, e: { r:0, c:16 }},    // Title
        {s: { r:3, c:0 }, e: { r:4, c:0 }},     // Date
        {s: { r:3, c:1 }, e: { r:4, c:1 }},     // Bill No 
        {s: { r:3, c:2 }, e: { r:4, c:2 }},     // Customer  
        {s: { r:3, c:3 }, e: { r:4, c:3 }},     // Ref. No
        {s: { r:3, c:4 }, e: { r:4, c:4 }},     // B/L No
        {s: { r:3, c:5 }, e: { r:4, c:5 }},     // CUR
        {s: { r:3, c:6 }, e: { r:3, c:7 }},     // AR
        {s: { r:3, c:8 }, e: { r:3, c:9 }},    // AP
        {s: { r:3, c:10 }, e: { r:3, c:11 }},   // Duty AR
        {s: { r:3, c:12 }, e: { r:3, c:13 }},   // Duty AP
        {s: { r:3, c:14 }, e: { r:3, c:16 }},   // Total
      ]
    }
  }
  wb.Sheets[title] = ws;
 
  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
  XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function depositSlipWithXLExport(title, domId, userId, headerInfo){
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };

  wb.SheetNames.push(title);

  const wsObjects = [];
  const headerName = [];
  const table = document.getElementById(domId);
  const columnWidths = [];

  if(table){
   if(headerInfo){
      headerInfo.forEach(x=>{
          wsObjects.push(x);
      });
   }
   const rows = table.querySelectorAll('div[role="row"]');
   rows.forEach((r,ri) => {
    if(r.id && r.id.includes('-header-row')){
      return;
    }
    const rowObj = [];
    let isSelect = false;
    let columnHorizontal = '';
    const columns = r.querySelectorAll('div[role="cell"]');
    columns.forEach((c, ci) => {
      const header = table.querySelector(`#${c.id.substring(0, c.id.indexOf('-cell-'))}-header-${ci}`);
      const headerKey = header?.innerText;
      
      if(headerKey !== 'No' && headerKey !== 'Deposit'){
        if (ri === 1) {
          if (headerKey) {
            headerName.push({v:headerKey, t:"s", s:{font:{bold: true}, alignment: {horizontal: 'center'}, 
                            border:{top:{style:'medium', color:'black'},
                                    right:{style:'medium', color:'black'},
                                    bottom:{style:'medium', color:'black'},
                                    left:{style:'medium', color:'black'}}}});
            columnWidths.push(c.getBoundingClientRect().width);
          }
        }
        if(c.innerHTML.includes('ifms-table-align-left')){
          columnHorizontal = 'left';
        }
        else if(c.innerHTML.includes('ifms-table-align-right')){
          columnHorizontal = 'right';
        }
        else {
          columnHorizontal = 'center';
        }
        rowObj.push({v:c.innerText, t:"s", s:{alignment: {horizontal: columnHorizontal}}});
      }
      if(ci === 8){
        if (c.getElementsByClassName('e-ifms-checkbox').length > 0) isSelect = true;
      }
    });
    if(isSelect) wsObjects.push(rowObj);
    });
    wsObjects.splice((headerInfo.length),0,headerName);
  } 


   const ws = XLSX.utils.aoa_to_sheet(wsObjects);
   ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
   ws["!merges"] = [
    {s: { r:0, c:0 }, e: { r:0, c:6 }},    // Title
  ]
    wb.Sheets[title] = ws;
    const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
    XLSX.writeFile(wb, fileTitle, { compression: true });

}

export function salesCostBatchRecogWithXLExport(title, tbId, userId, addData, listData) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };
  wb.SheetNames.push(title);

  const wsObjects = [];
  const headerName = [];
  const table = document.getElementById(tbId);
  const rowHeaderColumns = table.querySelectorAll('div[id*="header"]');
  const generalRow = table.querySelectorAll('div[role="row"]');
  const firstRow = generalRow[1];
  let columnWidths = [];

  let closedColumnIndex = -1;
  
  rowHeaderColumns.forEach((c, ci) => {
    if (ci === 0) return;
    
    columnWidths.push(c.getBoundingClientRect().width);
    
    let header = c.innerText ?? '';
    const headerKey = c.dataset.columnId ?? '';

    if (headerKey !== 'action' && headerKey !== 'scroll') {
      if (headerName.includes(header)) {
        header = header + 'Duptemp' + ci;
      }
      
      headerName.push(
        header.includes('Duptemp') 
          ? header.substring(0, header.indexOf('Duptemp'))
          : (headerKey === 'trStatus2' ? 'T' : header)
      );

      if (headerKey === 'closed') {
        closedColumnIndex = headerName.length - 1;
      }
    }
  });

  // + 컬럼에서 Period Close 데이터가 있으면 너비 2배로 늘리기
  if (closedColumnIndex !== -1 && listData.some(r => r['closed'] === 2)) {
    columnWidths[closedColumnIndex] *= 2;
  }

  if (addData && addData.length > 0) {
    addData.forEach((data, index) => {
      if (index === 0) {
        wsObjects.push(data);
      } else {
        // 두 번째 데이터부터 첫 번째 값은 A열, 두 번째 값은 D열에 위치
        let row = [];
        row[0] = data[0];
        row[3] = data[1];
        wsObjects.push(row);
      }
    });
  }

  wsObjects.push(headerName);

  if (listData && !!firstRow) {
    listData.forEach((r, rIndex) => {
      let rowObj = [];

      rowHeaderColumns.forEach((c, ci) => {
        if (ci === 0) return; 
        
        const headerKey = c.dataset.columnId ?? '';

        if (headerKey !== 'action' && headerKey !== 'scroll') {
          if (!!firstRow.querySelectorAll(`div[id*=${headerKey}-]`)) {
            const firstElement = firstRow.querySelectorAll(`div[id*=${headerKey}-]`)[0];

            if (firstElement === undefined) {
              if (headerKey === 'indicator') {
                rowObj.push((rIndex + 1) ?? '');
              } else if(headerKey === 'recogDate' || headerKey === 'firstDate') {
                rowObj.push(moment(r[headerKey]).format('YYYY-MM-DD'));
              } else if (headerKey === 'closed') {
                rowObj.push(r[headerKey] === 2 ? 'Period Close' : '');
              } else if(headerKey === 'selected') {
                rowObj.push(String(r[headerKey]).toLowerCase() === 'true' || r[headerKey] === 1 ? 1 : 0);
              } else {
                rowObj.push(r[headerKey] ?? '');
              }
            }
            else if (firstElement.className.includes('datetime'))
              rowObj.push(formatDateTime(r[headerKey]));
            else if (firstElement.className.includes('date'))
              rowObj.push(formatDate(r[headerKey]));
            else if (firstElement.className.includes('float'))
              rowObj.push(Decimalformat(r[headerKey], 2));
            else
              rowObj.push(r[headerKey] ?? '');
          }
          else {
            rowObj.push(r[headerKey] ?? '');
          }
        }
      });

      wsObjects.push(rowObj);
    });
  }

  const ws = XLSX.utils.aoa_to_sheet(wsObjects);
  ws["!cols"] = columnWidths.map(x => ({ wpx: x }));

  if (wsObjects.length > 0) {
    ws['!autofilter'] = { ref: `A5:${toColumnName(headerName.length)}${wsObjects.length}` };
  }

  wb.Sheets[title] = ws;
   
  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
  XLSX.writeFile(wb, fileTitle, { compression: true });
}
